import { useAuthStore } from '@/store/auth'
import { QueryStringKeys } from '@/constants/commons'
import type { LoginPendingAction } from '@/types/member'
import { RegistrationType } from '@/types/member'
import type { AuthActionType } from '@/types/auth'

import { GtmEvent } from '@/types/gtm'

export function useAuth() {
  tryOnMounted(() => {
    const authStore = useAuthStore()
    authStore.getAuth()
  })
}

export function useLogin() {
  const authStore = useAuthStore()
  const router = useLocaleRouter()
  const route = useRoute()
  const { fetchCollectionApi } = useCollection()
  const loginPendingAction = useLoginPendingActionCookie()

  const prepareForLogin = (pendingAction: LoginPendingAction) => {
    loginPendingAction.value = pendingAction
  }

  const checkAndExecutePendingAction = () => {
    if (!loginPendingAction.value) return

    const { type, payload } = loginPendingAction.value

    switch (type) {
      case 'addFavorite':
        fetchCollectionApi({ id: payload.id, type: payload.type, isFavorited: false })
        break
      default:
        break
    }

    loginPendingAction.value = null
  }

  const handleLoginSuccess = async (
    redirectUrl = '',
    registrationType: RegistrationType = RegistrationType.EMAIL,
    actionType: AuthActionType = 'login'
  ) => {
    const _redirectUrl = redirectUrl || route.query[QueryStringKeys.REDIRECT_URL]

    checkAndExecutePendingAction()
    await authStore.getAuth()
    if (authStore.isLoginModalShown) {
      authStore.closeLoginModal()
    }
    if (typeof _redirectUrl === 'string' && _redirectUrl) {
      router.replace(_redirectUrl)
    }

    const event = actionType === 'login' ? GtmEvent.ACCOUNT_LOGGED_IN : GtmEvent.ACCOUNT_SIGNED_UP
    const authTypePayloadKey = actionType === 'login' ? 'Login Type' : 'Registration Type'
    useNuxtApp().$trackEvent({
      event,
      payload: {
        [authTypePayloadKey]: registrationType,
      },
    })
  }

  return { prepareForLogin, handleLoginSuccess }
}
